import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Helper function to calculate a mock original price
  // matching the ratio seen in the visual reference (~1.43x)
  const getOriginalPrice = (priceStr) => {
    const price = parseFloat(priceStr);
    if (isNaN(price)) return "";
    return (price * 1.43).toFixed(2);
  };

  return (
    <div className="shop main">
      <h1 className="shop-title">Sale</h1>
      
      <div className="product-grid">
        {productData.map((item) => (
          <div className="product-card" key={item.id}>
            <Link to={`/shopDetails/${item.id}`} onClick={toTop}>
              <div className="image-container">
                <img src={item.image} alt={item.name} />
              </div>
              <div className="product-info">
                <h3 className="product-name">{item.name}</h3>
                <div className="product-prices">
                  <span className="sale-price">${item.price}</span>
                  <span className="original-price">${getOriginalPrice(item.price)}</span>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Shop;
